import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { DataApi } from 'src/app/Model/dataApi';
import { DataApiService } from 'src/app/services/data-api.service';
import { SeguridadService } from 'src/app/services/seguridad/seguridad.service';
import { ToastrServiceLocal } from 'src/app/services/toast/toastr.service';
import { MensajesHttpService } from 'src/app/utils/mensajesHttp/mensajes-http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificacionesFacadeService {
  
  private Notificaciones$ = new BehaviorSubject<any[]>([]);
  public responseNotificaciones$: Observable<any[]> = this.Notificaciones$.asObservable();

  private Cargando$ = new BehaviorSubject<boolean>(false);
  public responseCargando$: Observable<boolean> = this.Cargando$.asObservable();

  constructor(private _mensajesHttp: MensajesHttpService, private _toast: ToastrServiceLocal, private _dataApi: DataApiService, public seguridadService: SeguridadService) {
    
  }

  obtenerNotificaciones(modulo, callback) {
    const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/notificaciones/persona/0/modulo/`, 0, 8).pipe(
      tap((result: DataApi | any) => {
        if (result.data.table0) {
          callback(result.data.table0);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al mostrar las notificaciones', '');
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  marcarVisto(params, callback) {
    const request$ = this._dataApi.PutDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/notificaciones/${params?.idNotificacion}/visto`, params, 8).pipe(
      tap((result: DataApi | any) => {
        if (result.data.table0) {
          callback(result.data.table0);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.log(error)
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al marcar como visto la notificación', '');
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  marcarVistoTodos(params, callback) {
    const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/notificaciones/visto/all`, params, 8).pipe(
      tap((result: DataApi | any) => {
        if (result.data.table0) {
          callback(result.data.table0);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.log(error)
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al marcar como visto todas las notificaciónes', '');
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  mostrarHistorialNotificaciones(params: any) {
    this.Notificaciones$.next([]);
    this.Cargando$.next(true);
    const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/notificaciones/historico/ver/`, 0, 8).pipe(
      tap((result: DataApi | any) => {
        if (result.data.table0) {
          this.Notificaciones$.next(result.data.table0);
        }
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this.Notificaciones$.next([]);
        this.Cargando$.next(false);
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al mostrar el historico de notificaciones', '');
        return EMPTY;
      })
    );

    return request$.subscribe();
  }
}
